import React from 'react';
import { Button } from '@pinwheel/origami';
import useGetActionOnClick from './utils';
function Action(props) {
    var action = props.action;
    var dataTestId = "action-".concat(action.actionType);
    var onClick = useGetActionOnClick(action, props.onSubmit);
    var variant = props.isFirst ? undefined : 'ghost';
    return (React.createElement(Button, { "data-testid": dataTestId, sx: props.style, onClick: onClick, variant: variant }, action.label));
}
function Actions(props) {
    var actions = ((props === null || props === void 0 ? void 0 : props.actions) || []).map(function (action, i) { return (React.createElement(Action, { key: action.label, action: action, onSubmit: props.onSubmit, isFirst: i === 0 })); });
    return React.createElement(React.Fragment, null, actions);
}
export default Actions;
